<h1>{{ title }}</h1>

<mat-divider></mat-divider><br />
<form (submit)="this.submit()">
  <div class="row">
    <div class="col-sm d-flex justify-content-start" *ngIf="!!editarWeb; none">
      <button
        type="submit"
        mat-flat-button
        color="primary"
        [disabled]="desabilitarBotoes"
      >
        <span>{{ buttonTitle }}</span>
      </button>

      <button
        type="button"
        (click)="resetarForm()"
        mat-flat-button
        color="warn"
        class="ml-2"
        [disabled]="desabilitarBotoes"
      >
        <span>{{ buttonCancel }}</span>
      </button>
    </div>

    <div class="col-sm d-flex justify-content-end">
      <button
        *ngIf="this.idCaptacao"
        type="button"
        mat-flat-button
        color="primary"
        (click)="gerarPDF()"
      >
        <span>Anuência</span>
      </button>
      &nbsp;
      <button
        *ngIf="this.idCaptacao"
        type="button"
        mat-flat-button
        color="primary"
        (click)="gerarPDFAprovacao()"
      >
        <span>Termo de Consentimento</span>
      </button>
      &nbsp;
      <button
        *ngIf="this.idCaptacao"
        type="button"
        mat-flat-button
        color="primary"
        (click)="gerarPDFTriagem()"
      >
        <span>Triagem Clínica</span>
      </button>
    </div>
  </div>

  <mat-tab-group aria-disabled="app-doador">
    <mat-tab label="Cliente"
      ><app-doador
        [finalizarCliente]="finalizarCliente"
        [contratoValido]="contratoValido"
        [desabilitarFormResp]="desabilitarFormResp"
        [desabilitarBotoes]="desabilitarBotoes"
        [maiorDeIdade]="maiorDeIdade"
        [doador]="dadosCadastraisForm.controls.doador"
        [captacao]="dadosCadastraisForm.controls.captacao"
        [codigoDoador]="captacao.doador?.doador.codigo"
        (cep)="onCallParent()"
        (cpf)="onCPF()"
        (cepResponsavel1)="onCallParentResp1()"
        (cepResponsavel2)="onCallParentResp2()"
        (onFinalizarCliente)="onFinalizarCliente($event)"
      >
      </app-doador>
    </mat-tab>
    <mat-tab label="Coleta"
      ><app-coletor
        [termoValido]="termoValido"
        [finalizarEdColeta]="finalizarEdColeta"
        [captacao]="dadosCadastraisForm.controls.captacao"
        [editarWeb]="editarWeb"
        [desabilitarBotoes]="desabilitarBotoes"
        [captacaoTecidosCaptados]="captacaoTecidosCaptados"
        [tecidoCaptado]="dadosCadastraisForm.controls.tecidoCaptado"
        [idCaptacao]="idCaptacao"
        (onFichaValidaChange)="onFichaValidaChange($event)"
        (onIdadeChange)="onIdadeChange($event)"
        (onFinalizarColeta)="onFinalizarColeta($event)"
      ></app-coletor
    ></mat-tab>
    <!-- <mat-tab label="Tecidos Coletados"><app-tecidos-captados [editarWeb]="editarWeb"  [captacaoTecidosCaptados]="captacaoTecidosCaptados" [tecidoCaptado]="dadosCadastraisForm.controls.tecidoCaptado"></app-tecidos-captados></mat-tab> -->
    <h3>Escolha categoria</h3>

    <mat-form-field style="margin-top: 1rem">
      <input #input matInput placeholder="busque por nome" />
    </mat-form-field>
  </mat-tab-group>
</form>

<ng-template #spin>
  <button mat-raised-button color="primary" title="Clique para entrar">
    {{ status }}&nbsp;&nbsp;
    <app-spinner-angularmaterial></app-spinner-angularmaterial>
  </button>
</ng-template>

<div class="scroll-btn">
  <button
    mat-fab
    color="primary"
    aria-label="Example icon button with a delete icon"
    (click)="teste()"
    style="outline: none"
  >
    <mat-icon>north</mat-icon>
  </button>
</div>
